$( document ).ready(function() {
   // $('.list-color li input').closest(".rq-hover-change-image").find('.rq-get-hover-images').attr('src');
});


//$('body').(".products.collection  .rq-coll-swatch a").on({
$(document).on({
    mouseenter: function () {
        var get_image_add = $(this).closest(".rq-hover-change-image").find('.rq-get-hover-images').attr('src');
        $(this).closest(".product-card").find(".product-featured-image  .product-primary-image").attr('srcset', get_image_add);
    },
    mouseleave: function () {
        var get_image_add = $(this).closest(".rq-coll-swatch").find('.rq-hover-change-image.rq-border-color-boxes .rq-get-hover-images').attr('src');
        $(this).closest(".product-card").find(".product-featured-image  .product-primary-image").attr('srcset', get_image_add);
    }
}, ".products.collection  .rq-coll-swatch a");
/*$(document).on({
     alert("fv");
    mouseenter: function () {
      alert("fv");
      //  var get_image_add = $(this).closest(".rq-hover-change-image").find('.rq-get-hover-images').attr('src');
      //  $(this).closest("product-card").find(".product-featured-image  .product-primary-image").attr('src', get_image_add);
    },
    mouseleave: function () {
      // var get_image_add = $(this).closest(".rq-coll-swatch").find('.rq-hover-change-image .rq-get-hover-images').attr('src');
      // $(this).closest("product-card").find(".product-featured-image  .product-primary-image").attr('src', get_image_add);
  
    }
}, ".products.collection  .rq-coll-swatch a");*/
